import React, { useEffect, useState, useRef } from "react";
import "../../App.css";
import "./MainHeroSection.css";

const MainHeroSection = () => {
  // Overlay state removed since class toggle is handled directly
  const [isMobile, setIsMobile] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth <= 768);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const triggerPoint = window.innerHeight * 0.6; // show earlier for better UX
      if (window.scrollY > triggerPoint) {
        document.body.classList.add("show-overlay");
      } else {
        document.body.classList.remove("show-overlay");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;

    v.setAttribute("muted", "");
    v.setAttribute("playsinline", "");
    v.setAttribute("webkit-playsinline", "true");
    v.defaultMuted = true;
    v.muted = true;
    v.playsInline = true;

    let tries = 0;
    const maxTries = 8;

    const attemptPlay = () => {
      if (!v) return;
      const p = v.play();
      if (p && typeof p.then === "function") {
        p.then(() => {
          console.log("Video autoplayed successfully ✅");
        }).catch(() => {
          tries += 1;
          if (tries <= maxTries) {
            setTimeout(attemptPlay, 250 * tries);
          }
        });
      }
    };

    const onVisibility = () => {
      if (document.visibilityState === "visible") attemptPlay();
    };

    v.addEventListener("loadedmetadata", attemptPlay);
    v.addEventListener("canplay", attemptPlay);
    v.addEventListener("canplaythrough", attemptPlay);
    document.addEventListener("visibilitychange", onVisibility);

    const userKick = () => attemptPlay();
    window.addEventListener("pointerdown", userKick, { once: true });

    attemptPlay();

    return () => {
      v.removeEventListener("loadedmetadata", attemptPlay);
      v.removeEventListener("canplay", attemptPlay);
      v.removeEventListener("canplaythrough", attemptPlay);
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("pointerdown", userKick);
    };
  }, []);

  return (
    <>
      <section className="hero-wrap">
        {/* Full Background Video or GIF on Mobile */}
        <div className="hero-container">
          {isMobile ? (
            <img
              className="hero-gif"
              src={process.env.PUBLIC_URL + "/assets/beats-intro.gif"}
              alt="Beats Rest Mobile Background"
            />
          ) : (
            <video
              ref={videoRef}
              className="hero-video"
              muted
              autoPlay
              loop
              playsInline
              webkit-playsinline="true"
              x5-playsinline="true"
              preload="auto"
              poster={process.env.PUBLIC_URL + "/assets/beatsrest_cover.jpg"}
            >
              <source src="/assets/beats-intro-v3.mp4" type="video/mp4" />
            </video>
          )}
        </div>

        {/* Centered Logo */}
        <div className="hero-logo-center">
          <img
            src={process.env.PUBLIC_URL + "/assets/B-EATS-logo.png"}
            alt="Beats Rest Logo"
            className="hero-logo"
          />
          <h2 className="hero-subtitle">Urban Eatery</h2>
        </div>

        {/* Scroll Down Indicator */}
        <div className="scroll-down-indicator">
          <span className="arrow"></span>
          <span className="arrow"></span>
          <span className="arrow"></span>
        </div>
      </section>
    </>
  );
};

export default MainHeroSection;